package com.ives.modules.measurements;

class MeasurementData {
	public static inline var MEASUREMENT_DATA = "MEASUREMENT_DATA";

	public var points:Array<Float>;
	public var drawingId:String;
	public var imageId:String;
	public var type:String;
	public var measurementType:String;

	public function new(measurementType:String, imageId:String, points:Array<Float>, drawingId:String) {
		this.type = MEASUREMENT_DATA;
		this.measurementType = measurementType;
		this.imageId = imageId;
		this.points = points;
		this.drawingId = drawingId;
	}
}
